import { motion, useReducedMotion } from 'framer-motion';

// Shared scroll-reveal wrapper: fades/rises once when entering the viewport.
export const Reveal = ({ children, delay = 0, y = 24, className = '' }) => {
    const reduce = useReducedMotion();
    return (
        <motion.div
            className={className}
            initial={reduce ? false : { opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
        >
            {children}
        </motion.div>
    );
};
